import {PlayerReducer, ReducerFromState} from "../../../@types/reducers";
import {PlayerSettingsObject} from "../../../@types/response";

export const getSettings = (state: ReducerFromState<PlayerReducer>): PlayerSettingsObject => state.player.settings;